import { createContext } from 'react';

const DEFAULT_TIMEZONE = 'ETC/Utc';

export const TimezoneContext = createContext<string>(DEFAULT_TIMEZONE);
